module.exports = __webpack_public_path__ + "img/natural.58873d1.webp";